var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers2 = function SvgUsers2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4771E0",
    d: "M7 8c2.13 0 3.857-1.679 3.857-3.75S9.13.5 7 .5 3.143 2.179 3.143 4.25 4.87 8 7 8m1.528 1.406H5.472C2.59 9.406.25 11.68.25 14.483c0 .561.468 1.016 1.044 1.016h11.412c.577.001 1.044-.453 1.044-1.016 0-2.803-2.338-5.077-5.222-5.077"
  })));
};
export default SvgUsers2;